import { createDynamicSlice } from ".";
import {
  deleteStockThunk,
  detailsSaleListThunk,
  getDosageThunk,
  inventoryListThunk,
  removeSaleThunk,
  targetCropConcernThunk,
  updateSaleThunk,
  updateStockStatusThunk,
  updateStockThunk,
} from "../thunks/InventoryThunk";

const inventoryListSlice = createDynamicSlice({
  name: "inventoryListSlice",
  thunk: inventoryListThunk,
  listMode: true,
});

const detailsSaleListSlice = createDynamicSlice({
  name: "detailsSaleListSlice",
  thunk: detailsSaleListThunk,
});

const updateStockStatusSlice = createDynamicSlice({
  name: "updateStockStatusSlice",
  thunk: updateStockStatusThunk,
});

const deleteStockSlice = createDynamicSlice({
  name: "deleteStockSlice",
  thunk: deleteStockThunk,
});

const updateSaleSlice = createDynamicSlice({
  name: "updateSaleSlice",
  thunk: updateSaleThunk,
});

const removeSaleSlice = createDynamicSlice({
  name: "removeSaleSlice",
  thunk: removeSaleThunk,
});

const updateStockSlice = createDynamicSlice({
  name: "updateStockSlice",
  thunk: updateStockThunk,
});

const getDosageSlice = createDynamicSlice({
  name: "getDosageSlice",
  thunk: getDosageThunk,
});

const targetCropConcernSlice = createDynamicSlice({
  name: "targetCropConcernSlice",
  thunk: targetCropConcernThunk,
});





export const inventoryListReducer = inventoryListSlice.reducer;
export const updateStockStatusReducer = updateStockStatusSlice.reducer;
export const deleteStockReducer = deleteStockSlice.reducer;
export const updateSaleReducer = updateSaleSlice.reducer;
export const detailsSaleListReducer = detailsSaleListSlice.reducer;
export const removeSaleReducer = removeSaleSlice.reducer;
export const updateStockReducer = updateStockSlice.reducer;
export const getDosageReducer = getDosageSlice.reducer;
export const targetCropConcernReducer = targetCropConcernSlice.reducer;